import React from 'react'

import Interpretations from '../../../components/Interpretations'
import AddInterpretationButton from '../../../components/AddInterpretationButton'
import Confirmed from './Confirmed'
import { isEkgRecordingConfirmed } from '../../../constants'
import styles from '../EkgRecordingReviewScreen.css'

const NotesAndHistoryPane = props => {
  const {
    recording,
    toggleInterpretationHistoryExpanded,
    isInterpretationHistoryExpanded,
    fetchingRecording,
    interpretations,
    interpretationMap,
    handleOnShowAddInterpretationScreenClick,
    showInterpretations,
    me,
    isServiceProviderEnabled,
    qtAnalysisData,
    isQTEnabled,
    isServiceInterpretationFeatureEnabled,
  } = props

  let interpretationCount = 0

  if (recording) {
    if (recording.algorithmDetermination) {
      interpretationCount += 1
    }

    if (recording.memberInterpretations) {
      interpretationCount += recording.memberInterpretations.length
    }
  }
  // condition on the basis of isServiceProviderEnabled and isServiceInterpretationFeatureEnabled
  const checkServiceProviderAndInterpretationProvider = isServiceProviderEnabled && !isServiceInterpretationFeatureEnabled

  return (
    <div className={styles.patientAndHistoryPane}>
      <div className={styles.patientNotes}>
        <div className={styles.patientNotesHeader}>
          <div className={styles.left}>
            <h2>Patient Notes</h2>
          </div>
        </div>
        <p className={styles.note}>
          {recording && recording.note}
        </p>
      </div>
      {
        !checkServiceProviderAndInterpretationProvider ?
          <div className={styles.interpretationHistory}>
            <div className={styles.interpretationHistoryHeader}>
              <div className={styles.left}>
                <h2 className={styles.interpretationHistoryHeaderText}>Interpretation History</h2>
                {interpretationCount > 0 &&
                  <p className={styles.interpretationCount}>
                    <span>({interpretationCount})</span>
                  </p>
                }
              </div>
              <div className={styles.right}>
                {interpretationCount > 1 &&
                  <a className={styles.showAll} onClick={toggleInterpretationHistoryExpanded}>
                    {isInterpretationHistoryExpanded ? 'Hide History' : 'Show all'}
                  </a>
                }
              </div>
            </div>
            {/* ADD FORM POST */}
            {interpretations.data && recording &&
              <React.Fragment>
                <Interpretations
                  postingForm={false}
                  fetchingRecording={fetchingRecording}
                  historyExpanded={isInterpretationHistoryExpanded}
                  interpretationMap={interpretationMap}
                  recording={recording}
                  me={me}
                  isServiceProviderEnabled={isServiceProviderEnabled}
                  qtAnalysisData={qtAnalysisData}
                  isQTEnabled={isQTEnabled}
                />
                {isEkgRecordingConfirmed(recording) &&
                  <Confirmed confirmation={recording.memberInterpretations[0].confirmation} me={me} />
                }
                {!isEkgRecordingConfirmed(recording) &&
                  <AddInterpretationButton
                    onClick={handleOnShowAddInterpretationScreenClick}
                  />
                }
              </React.Fragment>
            }
          </div> : null
      }
    </div>
  )
}
export default NotesAndHistoryPane



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/NotesAndHistoryPane.jsx